import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import adminServices from "./adminServices";
const admin = JSON.parse(localStorage.getItem("admin"));
admin;
const initialState = {
  admin: admin ? admin : null,
  isSuccess: false,
  isError: false,
  isLoading: false,
  message: "",
};

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    reset: (state) => {
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(adminLogin.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(adminLogin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.message = "";
        state.admin = action.payload;
      })
      .addCase(adminLogin.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
        state.admin = "";
      })
      .addCase(adminLogout.fulfilled, (state, action) => {
        state.admin = null;
      });
  },
});

export const adminLogin = createAsyncThunk(
  "/admin/login",
  async (adminDetails, thunkAPI) => {
    try {
      return await adminServices.adminLogin(adminDetails);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const adminLogout = createAsyncThunk("admin/logout", async () => {
  return await adminServices.adminLogout();
});

export default adminSlice.reducer;
export const { reset } = adminSlice.actions;
